import React, { useState } from "react";
import Event from "./Event"; // Assuming you already have this component
import Modal1 from "../modals/Modal1";

const EventModal = ({
  parsed_date,
  event,
  setEvent,
  children,
  setModalOpen,
  open,
  setOpen,
  orgData,
  userData,
  onDelete,
  onUpdate,
  navigateWorkspace,
  workspaceData,
  temporary,
  setTemporary,
}) => {
  const [cannot_close, setCannotClose] = useState(false);
  const handleOpen = (e) => {
    e.stopPropagation();
    setOpen(true);

    //setModalOpen(true); // Notify parent that modal is open
  };
  const handleFetchAgain = (id) => {
    setOpen(false);
    setModalOpen(false); // Notify parent that modal is closed
    onDelete(id);
  };

  const [colors = [], setColors] = useState([]);

  const handleUpdate = () => {
    setOpen(false);
    onUpdate();
  };

  const handleClose = (go = false) => {
    if (go || !cannot_close) {
      setOpen(false);
      setTemporary(false);
    }
    // Notify parent that modal is closed
  };

  return (
    event && (
      <div className=" h-full w-full justify-center items-center align-middle bg-transparent ">
        {/* Button to open the modal */}
        <div
          onClick={handleOpen}
          className="h-fit w-full cursor-pointer bg-transparent"
        >
          {children}
        </div>
        {/* Modal dialog */}
        <div className="bg-indigo-100">
          <Modal1 onClose={handleClose} isOpen={open}>
            <div className="bg-white flex flex-col p-4 rounded-xl">
              <Event
                parsed_date={parsed_date}
                event_id={event.id}
                setEvent={setEvent}
                orgData={orgData}
                userData={userData}
                onClose={handleClose}
                onCloseEvent={handleClose}
                onDelete={handleFetchAgain}
                onUpdate={handleUpdate}
                setCannotClose={setCannotClose}
                navigateWorkspace={navigateWorkspace}
                workspaceData={workspaceData}
                temporary={temporary}
                setTemporary={setTemporary}
              />
            </div>
          </Modal1>
        </div>
      </div>
    )
  );
};

export default EventModal;
